import {Map} from 'immutable';
import  * as actions from '../actions/ClosePO';
import * as constants from 'constants/App';

/* Handles invoice details values on change event*/
export function onChangeHandlerClosePO(dispatch, poInvoiceDetails) {
    dispatch(actions.saveInvoiceDetails(poInvoiceDetails));
}

/* Edit PO*/
export function onEditPOHandler(dispatch, trackNumber) {
    //redirect to the shop view
    const poEditPath = `/PO/edit/${trackNumber}`;
    dispatch({type: constants.NAVIGATE_TO, path: poEditPath});
}